var _effectorFileName = "/src/page-content/teachers/components/teachers/teachers.tsx";
import { useEffect, useMemo, useState } from 'react';
import { TEACHERS_LIST } from '@/pages/api/teachers/constants';
import type { Teacher } from '@/pages/api/teachers/types';
import { useTranslation } from 'next-i18next';
import { divideArrayIntoEqualParts, EqualParts } from '@/widgets/layouts/main/constants/array-divider';
import { MagicContainer } from '@/shared/components/animation/magic-container';
import { Article } from '@/shared/components/article';
import { DisplayOnBrowserMount } from '@/shared/components/display-on-browser-mount';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/lib/cn';
import { TeacherCard } from './teacher-card';
export const Teachers = () => {
  const {
    t
  } = useTranslation('teachers-list');
  const [isBlockFullyVisible, setVisibilityState] = useState<boolean>(false);
  const [teachersListDivided, setTeachersListDivided] = useState<EqualParts<Teacher>>([]);
  const localizedTeachers = useMemo(() => {
    return TEACHERS_LIST.map(teacher => ({
      ...teacher,
      name: t(teacher.name),
      surname: t(teacher.surname),
      patronymicName: t(teacher.patronymicName),
      facts: teacher.facts.map(fact => t(fact))
    }));
  }, [t]);
  useEffect(() => {
    const getPartsCount = () => {
      if (window.innerWidth < 420) return 1; // Mobile
      if (window.innerWidth < 768) return 2; // Tablet
      if (window.innerWidth < 1024) return 3; // Tablet
      return 4; // Large Screens
    };
    const parts = getPartsCount();
    const dividedArray = divideArrayIntoEqualParts<Teacher>(localizedTeachers, parts);
    setTeachersListDivided(dividedArray);
  }, [localizedTeachers]);
  return <Article>
      <h2 className="mb-4 header-h2 sm:mb-8">{t('title')}</h2>

      <DisplayOnBrowserMount>
        <div className="relative">
          <div className={cn('grid transform grid-cols-1 gap-4 overflow-hidden transition-[max-height] duration-700 ease-out motion-reduce:transition-none motion-reduce:hover:transform-none xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:gap-8', {
          'max-h-[500px] sm:max-h-[800px]': !isBlockFullyVisible
        }, {
          'max-h-auto': isBlockFullyVisible
        })}>
            {teachersListDivided.length > 0 && teachersListDivided.map((list, index) => {
            return <MagicContainer key={index} className="space-y-4 xl:space-y-8">
                    {list.map(teacher => {
                return <TeacherCard key={teacher.id} name={teacher.name} surname={teacher.surname} patronymicName={teacher.patronymicName} img={teacher.img} facts={teacher.facts} className="mx-auto h-fit w-full max-w-[350px] p-4 pb-6" />;
              })}
                  </MagicContainer>;
          })}
          </div>

          {!isBlockFullyVisible && <div className="pointer-events-none absolute bottom-0 -mt-24 ml-[50%] flex w-screen -translate-x-1/2 transform justify-center bg-gradient-to-t from-white pb-8 pt-32 dark:from-black/100">
              <Button className="pointer-events-auto" onClick={() => setVisibilityState(true)} aria-label={t('aria.showMore')}>
                {t('showMore')}
              </Button>
            </div>}

          {isBlockFullyVisible && <div className="pointer-events-none sticky bottom-0 -mt-0 ml-[50%] flex w-screen -translate-x-1/2 transform justify-center bg-gradient-to-t from-white pb-8 pt-10 opacity-100 transition-opacity duration-300 dark:from-gray-900">
              <Button className="pointer-events-auto" onClick={() => setVisibilityState(false)} aria-label={t('aria.hide')}>
                {t('hide')}
              </Button>
            </div>}
        </div>
      </DisplayOnBrowserMount>
    </Article>;
};